import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaTrophy, FaArrowLeft, FaCheck } from 'react-icons/fa';
import toast from 'react-hot-toast';
import api from '../../api/axios';

export default function AdminCreateMundial() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    nom: '',
    description: '',
    prize_money: '',
    prize_description: '',
    prize_coins: '0',
    entry_fee: '0',
    premium_only: true,
    registration_deadline: '',
    group_stage_deadline: '',
    knockout_deadline: '',
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.nom.trim()) {
      toast.error('Le nom est requis');
      return;
    }

    setLoading(true);
    try {
      const { data } = await api.post('/championships', {
        ...form,
        format: 'mundial',
        prize_coins: parseInt(form.prize_coins) || 0,
        entry_fee: parseInt(form.entry_fee) || 0,
      });

      toast.success('Tournoi Mondial créé!');
      navigate('/admin/championships');
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Erreur lors de la création');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen p-6" style={{ background: '#0d2b1a' }}>
      {/* Header */}
      <div className="mb-8 flex items-center gap-3">
        <button
          onClick={() => navigate('/admin/championships')}
          className="text-white/60 hover:text-white transition-colors"
        >
          <FaArrowLeft size={20} />
        </button>
        <h1 className="text-3xl font-black text-qfl-gold uppercase" style={{ fontFamily: "'Rajdhani', sans-serif" }}>
          🌍 Créer un Tournoi Mondial
        </h1>
      </div>

      {/* Form */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-2xl mx-auto rounded-2xl p-6"
        style={{ background: 'rgba(20, 60, 40, 0.8)', border: '1px solid rgba(240,180,41,0.2)' }}
      >
        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Format Badge */}
          <div className="p-4 rounded-xl bg-blue-500/20 border border-blue-500/30 text-center">
            <p className="text-blue-400 font-bold text-sm" style={{ fontFamily: "'Rajdhani', sans-serif" }}>
              FORMAT: Mondial (12 poules × 4 joueurs = 48 max)
            </p>
          </div>

          {/* Nom */}
          <div>
            <label className="text-white/70 text-sm font-bold block mb-2">Nom du Tournoi *</label>
            <input
              type="text"
              name="nom"
              value={form.nom}
              onChange={handleChange}
              placeholder="Ex: Coupe du Monde 2026"
              className="w-full px-4 py-2.5 rounded-lg bg-white/5 border border-white/20 text-white placeholder-white/30 focus:border-qfl-gold/50 focus:outline-none transition"
            />
          </div>

          {/* Description */}
          <div>
            <label className="text-white/70 text-sm font-bold block mb-2">Description</label>
            <textarea
              name="description"
              value={form.description}
              onChange={handleChange}
              placeholder="Ex: Tournoi mondial avec groupes de 4..."
              rows="3"
              className="w-full px-4 py-2.5 rounded-lg bg-white/5 border border-white/20 text-white placeholder-white/30 focus:border-qfl-gold/50 focus:outline-none transition"
            />
          </div>

          {/* Grid: Prizes & Fees */}
          <div className="grid grid-cols-2 gap-4">
            {/* Prize Money */}
            <div>
              <label className="text-white/70 text-sm font-bold block mb-2">Prize Argent (FCFA)</label>
              <input
                type="text"
                name="prize_money"
                value={form.prize_money}
                onChange={handleChange}
                placeholder="Ex: 500000"
                className="w-full px-4 py-2.5 rounded-lg bg-white/5 border border-white/20 text-white placeholder-white/30 focus:border-qfl-gold/50 focus:outline-none transition"
              />
            </div>

            {/* Prize Coins */}
            <div>
              <label className="text-white/70 text-sm font-bold block mb-2">Prize Pièces</label>
              <input
                type="number"
                name="prize_coins"
                value={form.prize_coins}
                onChange={handleChange}
                placeholder="0"
                className="w-full px-4 py-2.5 rounded-lg bg-white/5 border border-white/20 text-white placeholder-white/30 focus:border-qfl-gold/50 focus:outline-none transition"
              />
            </div>
          </div>

          {/* Entry Fee */}
          <div>
            <label className="text-white/70 text-sm font-bold block mb-2">Frais d'entrée (FCFA)</label>
            <input
              type="number"
              name="entry_fee"
              value={form.entry_fee}
              onChange={handleChange}
              placeholder="0"
              className="w-full px-4 py-2.5 rounded-lg bg-white/5 border border-white/20 text-white placeholder-white/30 focus:border-qfl-gold/50 focus:outline-none transition"
            />
          </div>

          {/* Prize Description */}
          <div>
            <label className="text-white/70 text-sm font-bold block mb-2">Détail des Prix</label>
            <input
              type="text"
              name="prize_description"
              value={form.prize_description}
              onChange={handleChange}
              placeholder="Ex: 1er: 200000F, 2e: 100000F, 3e: 50000F"
              className="w-full px-4 py-2.5 rounded-lg bg-white/5 border border-white/20 text-white placeholder-white/30 focus:border-qfl-gold/50 focus:outline-none transition"
            />
          </div>

          {/* Dates */}
          <div className="grid grid-cols-3 gap-3">
            <div>
              <label className="text-white/70 text-sm font-bold block mb-2">Fin Inscriptions</label>
              <input
                type="datetime-local"
                name="registration_deadline"
                value={form.registration_deadline}
                onChange={handleChange}
                className="w-full px-4 py-2.5 rounded-lg bg-white/5 border border-white/20 text-white focus:border-qfl-gold/50 focus:outline-none transition text-sm"
              />
            </div>
            <div>
              <label className="text-white/70 text-sm font-bold block mb-2">Fin Groupes</label>
              <input
                type="datetime-local"
                name="group_stage_deadline"
                value={form.group_stage_deadline}
                onChange={handleChange}
                className="w-full px-4 py-2.5 rounded-lg bg-white/5 border border-white/20 text-white focus:border-qfl-gold/50 focus:outline-none transition text-sm"
              />
            </div>
            <div>
              <label className="text-white/70 text-sm font-bold block mb-2">Fin K.O.</label>
              <input
                type="datetime-local"
                name="knockout_deadline"
                value={form.knockout_deadline}
                onChange={handleChange}
                className="w-full px-4 py-2.5 rounded-lg bg-white/5 border border-white/20 text-white focus:border-qfl-gold/50 focus:outline-none transition text-sm"
              />
            </div>
          </div>

          {/* Premium Only */}
          <div className="flex items-center gap-3 p-3 rounded-lg bg-white/5 border border-white/20">
            <input
              type="checkbox"
              id="premium_only"
              name="premium_only"
              checked={form.premium_only}
              onChange={handleChange}
              className="w-4 h-4 rounded cursor-pointer"
            />
            <label htmlFor="premium_only" className="text-white/70 text-sm cursor-pointer flex-1">
              Réservé Premium seulement
            </label>
          </div>

          {/* Submit */}
          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 rounded-lg font-black uppercase tracking-widest transition-all text-sm"
            style={{
              background: loading ? 'rgba(240,180,41,0.3)' : 'linear-gradient(135deg, #f0b429, #c97d08)',
              color: loading ? 'rgba(255,255,255,0.5)' : '#0d2b1a',
              opacity: loading ? 0.6 : 1,
            }}
            onMouseEnter={(e) => !loading && (e.target.style.background = 'linear-gradient(135deg, #ffc043, #d98a15)')}
            onMouseLeave={(e) => !loading && (e.target.style.background = 'linear-gradient(135deg, #f0b429, #c97d08)')}
          >
            {loading ? (
              <span className="flex items-center justify-center gap-2">
                <div className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
                Création...
              </span>
            ) : (
              <span className="flex items-center justify-center gap-2">
                <FaCheck size={14} /> Créer le Tournoi Mondial
              </span>
            )}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
